/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3.304 4.8h17.392c.72 0 1.304.584 1.304 1.304v11.74c0 .72-.584 1.304-1.305 1.304h-8.56l-5.54 3.835a.435.435 0 0 1-.682-.357v-3.478H3.304A1.269 1.269 0 0 1 2 17.888V6.105c0-.72.584-1.304 1.304-1.304ZM12 7c-.4 0-.8.3-.8.8v4c0 .5.3.8.8.8.4 0 .8-.3.8-.8v-4c0-.4-.3-.8-.8-.8Zm1.3 8.15a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0Z"
})), "0 0 24 24", "Feedback");